module.exports = __webpack_public_path__ + "ac5fd8be615b211e57c37dba324e24e3.jpg";